(function () {
    const LOGGER_EP = '/api/postlog';
    const LOGGER_ENABLED = true;
    function Fetch() {
        const defaults = {
            headers: {
                Accept: 'application/json',
                'Accept-Encoding': 'gzip, deflate, br',
                'Content-Type': 'application/json'
            },
            data: false,
            timeout: 30000,
            method: 'GET',
            credentials: 'same-origin',
            payloadEncode: 'raw',
            token: {
                enable: false,
                uri: '/session/token',
                header: 'X-CSRF-Token',
            },
        };
        function init(uri, config) {
            config = extend(true, defaults, config);
            return new Promise((resolve, reject) => {
                const currToken = JSON.parse(sessionStorage.getItem('ecoop_token')) || {};
                if (validateToken(currToken) || !config.token.enable) {
                    resolve(currToken.value);
                }
                else {
                    if (config.token.uri) {
                        retry(() => {
                            return fetch(config.token.uri, {
                                method: 'GET',
                            });
                        }, 10)
                            .then(token => {
                            token.text().then(token => {
                                storeToken(token);
                                resolve(token);
                            });
                        })
                            .catch(() => {
                            reject('Unable to retrieve token');
                        });
                    }
                    else {
                        throw new Error('Token request was enabled but no uri was set.');
                    }
                }
            }).then(authToken => {
                let { method, headers, data, timeout, token, credentials, payloadEncode } = config;
                if (uri) {
                    let body;
                    if (method === 'POST') {
                        body = encodePayload(data, payloadEncode);
                    }
                    else {
                        let keys = '';
                        for (let key in data) {
                            if (data.hasOwnProperty(key)) {
                                const val = data[key];
                                keys += `${key}=${val}&`;
                            }
                        }
                        if (keys) {
                            uri = `${uri}?${keys.slice(0, -1)}`;
                        }
                    }
                    if (token.enable && authToken) {
                        headers[token.header] = authToken;
                    }
                    return timeoutHandler(timeout, fetch(uri, {
                        headers,
                        method,
                        body,
                        credentials,
                    }));
                }
            });
        }
        function encodePayload(data, method) {
            let ret;
            if (method === 'raw') {
                ret = typeof data === 'object' ? JSON.stringify(data) : data;
            }
            else if (method === 'formData') {
                const formData = new FormData();
                for (let param in data) {
                    if (data.hasOwnProperty(param)) {
                        formData.append(param, data[param]);
                    }
                }
                ret = formData;
            }
            else if (method === 'urlEncoded') {
                ret = typeof data === 'object' ? new URLSearchParams(data) : data;
            }
            else {
                throw 'Unsupported payload encoding requested.';
            }
            return ret;
        }
        function storeToken(token) {
            if (token) {
                const TEN_MINUTES = 600000;
                const timestamp = new Date().getTime() + TEN_MINUTES;
                sessionStorage.setItem('ecoop_token', JSON.stringify({
                    value: token,
                    timestamp,
                }));
            }
        }
        function validateToken(token) {
            const now = new Date().getTime();
            return token && token.timestamp > now && token.value;
        }
        function timeoutHandler(ms, promise) {
            return new Promise(function (resolve, reject) {
                setTimeout(function () {
                    reject(new Error('Timeout'));
                }, ms);
                promise.then(resolve, reject);
            }).then(response => {
                const status = response.status;
                if (response.ok || status === 200) {
                    return response.json();
                }
                else {
                    if (response.url.indexOf(LOGGER_EP) < 0) {
                        _flog(status, response.statusText, { url: response.url }, {});
                    }
                }
            });
        }
        return init;
    }
    function retry(promise, counter) {
        return new Promise((resolve, reject) => {
            retryHelper(promise, counter);
            function retryHelper(promise, counter) {
                promise()
                    .then(data => {
                    resolve(data);
                })
                    .catch(() => {
                    if (counter > 0) {
                        setTimeout(() => {
                            retryHelper(promise, --counter);
                        }, 500);
                    }
                    else {
                        reject();
                    }
                });
            }
        });
    }
    function _flog(status_code, error_code, req, res) {
        let arr = [].constructor;
        let obj = {}.constructor;
        req =
            req.constructor === arr || req.constructor === obj
                ? JSON.stringify(req)
                : (req.toString && req.toString()) || req || '{}';
        res =
            res.constructor === arr || res.constructor === obj
                ? JSON.stringify(res)
                : (res.toString && res.toString()) || res || '{}';
        const msg = `REQUEST: ${req} - RESPONSE: ${res}`;
        LOGGER_ENABLED
            ? Fetch()(LOGGER_EP, {
                method: 'POST',
                data: {
                    msg,
                    timestamp: new Date().getTime(),
                    error_code: error_code.message,
                    status_code,
                },
                token: {
                    enable: true,
                },
            })
            : console.log({
                msg,
                timestamp: new Date().getTime(),
                error_code: error_code.message,
                status_code,
            });
    }
    publish(_flog, '_flog');
    publish(Fetch(), 'Fetch');
})();
